/*
 * Copyright (c) 2023 NEXTwfl INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTwfl INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from "@irian-ro/abstract-resource";
import {ValidIntervalModel} from "./valid-interval.model";

export class WorkflowConfigVoModel extends JSONable {
  uuid: string | null = null;
  owner: string | null = null;
  label: string | null = null;
  validInterval: ValidIntervalModel | null = null;
  configuredBy: string | null = null;

}
